import { Directive, DoCheck, ElementRef, HostBinding } from '@angular/core';

// Removes Angular Material MatSelect's static host attribute
// `aria-autocomplete="none"`.
//
// Why: mat-select is a select-only combobox with no text-entry autocomplete.
// `none` is already the ARIA default for role="combobox", so emitting it
// explicitly is redundant and was flagged by the WCAG audit. Stripping it
// leaves the rest of the combobox semantics intact — role="combobox",
// aria-expanded, and the panelOpen-bound aria-controls are untouched. See
// node_modules/@angular/material/fesm2020/select.mjs for the upstream static
// attribute this directive overrides.
//
// The HostBinding handles the common case; ngDoCheck is a defensive fallback
// for the directive-ordering race with MatSelect's own host attribute, mirroring
// NoMatInputAriaRequiredDirective.
@Directive({
  selector: 'mat-select'
})
export class NoMatSelectAriaAutocompleteDirective implements DoCheck {
  @HostBinding('attr.aria-autocomplete') readonly ariaAutocomplete: null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngDoCheck(): void {
    const node = this.el.nativeElement;
    if (node.getAttribute('aria-autocomplete') === 'none') {
      node.removeAttribute('aria-autocomplete');
    }
  }
}
